import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import Page from '../../components/Page';
import BulletinForm from '../../sections/@dashboard/bulletins/BulletinForm';

// ---------------------------------------------------------------------

export default function SaveBulletin() {
  const { t } = useTranslation();

  return (
    <Page title={t('bulletin_form')}>
      <Container maxWidth="xl">
        <Typography variant="h4" fontWeight={800} gutterBottom mb={4}
          sx={{ color: '#032C65' }}
        >
          {t('new_bulletin') || 'Nuevo Boletín'}
        </Typography>
        <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
          <BulletinForm />
        </Box>
      </Container>
    </Page>
  );
}
